// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d2077b97","88":"bbe938f8","148":"892c93d3","235":"c3881940","488":"52655d6e","948":"7c015c79"}[chunkId] + ".chunk.js";
};